import * as React from 'react';
import { connect } from 'react-redux';
import { FeatureFlagKey } from '@atlassian/cssxp-typescommon';
import { SecurityStateTree } from '../reducers/security';
import { getFeatureFlag } from '../selectors';

interface ChildProps {
  children: React.ReactNode;
}

export class Enabled extends React.Component<ChildProps> {
  render() {
    return this.props.children;
  }
}

export class Disabled extends React.Component<ChildProps> {
  render() {
    return this.props.children;
  }
}

type FeatureSwitchChildComponent = React.ReactElement<typeof Enabled> | React.ReactElement<typeof Disabled>;

export interface FeatureSwitchProps {
  children: FeatureSwitchChildComponent | FeatureSwitchChildComponent[];
  flag: FeatureFlagKey;
  hasFlag: boolean;
}

/*
 * Feature Switch Component
 * Conditionally renders either the Enabled component or the Disabled component
 *
 * usage:
 *   <FeatureSwitch flag="cassi.example.flag">
 *       <Enabled>{featureComponent}</Enabled>
 *       <Disabled>{fallbackComponent}</Disabled>
 *   <FeatureSwitch />
 *
 */
class StatelessFeatureSwitch extends React.Component<FeatureSwitchProps> {
  render() {
    if (this.props.hasFlag) {
      return React.Children.map(this.props.children, (child) =>
        React.isValidElement(child) && child.type === Enabled ? child : null
      );
    } else {
      return React.Children.map(this.props.children, (child) =>
        React.isValidElement(child) && child.type === Disabled ? child : null
      );
    }
  }
}

const mapStateToProps = (state: SecurityStateTree, ownProps: { flag: FeatureFlagKey }) => ({
  hasFlag: getFeatureFlag(ownProps.flag)(state),
});

export const FeatureSwitch = connect(mapStateToProps)(StatelessFeatureSwitch);
